import { render, staticRenderFns } from "./MailSendChart.vue?vue&type=template&id=995f19a0&scoped=true"
import script from "./MailSendChart.vue?vue&type=script&lang=js"
export * from "./MailSendChart.vue?vue&type=script&lang=js"
import style0 from "./MailSendChart.vue?vue&type=style&index=0&id=995f19a0&prod&lang=scss"
import style1 from "./MailSendChart.vue?vue&type=style&index=1&id=995f19a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995f19a0",
  null
  
)

export default component.exports